import { create } from './create';

export const memberships = {
  create,
};
